module.exports = __webpack_public_path__ + "img/logo-grupo-cometa-negativo.77a7e1b7.svg";